var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackLineTwo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 538.1 562.6",
    style: {
      enableBackground: "new 0 0 538.1 562.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.0869,
    y1: 562.6195,
    x2: 267.0869,
    y2: -9.094947e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1EBF7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.3,539.9l-89-53.5c-24.3-14.6-83-15.8-107.9-29.4C3.9,426.6-0.4,371.1,0,320.9 c0.2-22.1,3.8-44.1,10.8-65.1L35.4,182c0-71.4-21.4-182,50-182l0,0c212.2,21.1,239.4,111.4,242.1,182.9c1.1,29.8,64.5,60,88.9,77.1 l70.2,44.4c2.7,3.4,5.6,6.7,8.8,9.6c33.2,31,52.8,143.1,26.7,180.8c-9.9,14.3-77.8,42-135.1,60.3 C343.3,569,295.6,563.5,256.3,539.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLineTwo);
export default __webpack_public_path__ + "static/media/back-line-two.d740d088d586bdaeed89aa88b71175bb.svg";
export { ForwardRef as ReactComponent };